import React, { useState } from "react";
import AdminManageAccess from "../components/AdminManageAccess.jsx";
import AdminAddUser from "../components/AdminAddUser.jsx";
import AdminManageUser from "../components/AdminManageUser.jsx";

const AdminDashboard = () => {
  // use integer instead of string
  const [activeTab, setActiveTab] = useState("addUser");

  const renderComponent = () => {
    switch (activeTab) {
      case "addUser":
        return <AdminAddUser />;
      case "manageUser":
        return <AdminManageUser />;
      case "manageRole":
        return <AdminManageAccess />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full py-20 px-14">
      <div className="flex flex-row justify-between text-center gap-4">
        <div
          className={`w-full border rounded-md border-blue-500 py-2 cursor-pointer ${
            activeTab === "addUser" ? "bg-blue-500 text-white" : ""
          }`}
          onClick={() => setActiveTab("addUser")}
        >
          Add New User
        </div>
        <div
          className={`w-full border rounded-md border-blue-500 py-2 cursor-pointer ${
            activeTab === "manageUser" ? "bg-blue-500 text-white" : ""
          }`}
          onClick={() => setActiveTab("manageUser")}
        >
          Manage User
        </div>
        <div
          className={`w-full border rounded-md border-blue-500 py-2 cursor-pointer ${
            activeTab === "manageRole" ? "bg-blue-500 text-white" : ""
          }`}
          onClick={() => setActiveTab("manageRole")}
        >
          Manage Role and Access
        </div>
      </div>
      <div className="pt-2">{renderComponent()}</div>
    </div>
  );
};

export default AdminDashboard;
